import React, {memo} from "react";

export const IconHDFeather = memo(({color, addClass}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19V20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20V19C14.9706 19 19 14.9706 19 10Z"
        fill={color || "#fff"}
      />
      <path
        d="M11.4615 5.73077V14.2692H9.4671V10.6593H5.99444V14.2692H4V5.73077H5.99444V9.2997H9.4671V5.73077H11.4615Z"
        fill={color || "#fff"}
      />
      <path
        d="M17.4663 9.99707C17.4663 10.6144 17.3601 11.1848 17.1475 11.7083C16.9388 12.2279 16.6432 12.6791 16.2606 13.062C15.8781 13.441 15.4163 13.7379 14.8752 13.9528C14.3381 14.1637 13.741 14.2692 13.0841 14.2692H11.4615V5.73077H13.0841C13.741 5.73077 14.3381 5.83821 14.8752 6.05309C15.4163 6.26797 15.8781 6.56489 16.2606 6.94386C16.6432 7.32282 16.9388 7.77407 17.1475 8.29759C17.3601 8.8172 17.4663 9.3837 17.4663 9.99707ZM15.4607 9.99707C15.4607 9.57513 15.4066 9.19421 15.2984 8.85432C15.1902 8.51442 15.0337 8.22726 14.8289 7.99285C14.6279 7.75453 14.3806 7.57286 14.0869 7.44784C13.7932 7.31892 13.4589 7.25445 13.0841 7.25445H11.4615V12.7456H13.0841C13.4589 12.7456 13.7932 12.683 14.0869 12.558C14.3806 12.4291 14.6279 12.2474 14.8289 12.013C15.0337 11.7747 15.1902 11.4856 15.2984 11.1457C15.4066 10.8058 15.4607 10.4229 15.4607 9.99707Z"
        fill={color || "#fff"}
      />
    </svg>
  );
});
